import setup from './hawk-search-commerce-tracker';

setup();
